import React, { useEffect, useState } from 'react';
import { useCurrentDebrief, useDebriefApp } from 'ff/debrief/hooks';
import { SegmentVrefOverride } from 'ff/debrief/models';
import TextField from 'ff/debrief/common/components/TextField';
import EditControls from 'ff/debrief/components/segments/EditControls';
import InputAdornment from '@mui/material/InputAdornment';
import Theme from 'ff/debrief/common/StyledComponentThemes';

const VrefInputField = () => {
    const { selectedSegment } = useDebriefApp();
    const { saveVrefOverride, resetVrefOverride } = useCurrentDebrief();

    const [vrefValue, setVrefValue] = useState(
        selectedSegment.approachParameters?.vref
    );
    const [isEditMode, setIsEditMode] = useState(false);

    useEffect(() => {
        if (selectedSegment.approachParameters) {
            setVrefValue(selectedSegment.approachParameters.vref);
        }
    }, [selectedSegment.approachParameters]);

    const handleVrefChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!isEditMode) return;

        // Removes non-numerical input values
        const newValue = event.currentTarget.value.replace(/[^0-9.]/g, '');
        setVrefValue(newValue === '' ? null : parseFloat(newValue));
    };

    const createVrefOverride = (): SegmentVrefOverride => ({
        startEpochSecond: selectedSegment.startUtc,
        duration: selectedSegment.durationInSeconds,
        vref: vrefValue,
    });

    const handleSaveVref = () => {
        if (vrefValue != selectedSegment.approachParameters.vref) {
            saveVrefOverride(createVrefOverride());
        }
        setIsEditMode(false);
    };

    const handleResetVref = () => {
        resetVrefOverride(createVrefOverride());
        setIsEditMode(false);
    };

    const handleCancelEdit = () => {
        setVrefValue(selectedSegment.approachParameters?.vref);
        setIsEditMode(false);
    };

    if (!selectedSegment.approachParameters) return null;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                maxWidth: '65%',
            }}
        >
            <TextField
                label={`Vref (${selectedSegment.approachParameters.vrefSource || ''})`}
                value={vrefValue || ''}
                onChange={handleVrefChange}
                InputProps={{
                    readOnly: !isEditMode,
                    endAdornment: (
                        <InputAdornment position="end">
                            <EditControls
                                isEditMode={isEditMode}
                                onEditClick={() => setIsEditMode(true)}
                                onSaveClick={handleSaveVref}
                                onResetClick={handleResetVref}
                                onCancelClick={handleCancelEdit}
                                vrefSource={
                                    selectedSegment.approachParameters
                                        .vrefSource
                                }
                            />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    '& .MuiInputBase-input:focus': {
                        color: isEditMode ? Theme.blue : 'inherit',
                        fontWeight: isEditMode ? 'bold' : 'normal',
                    },
                }}
            />
        </div>
    );
};

export default VrefInputField;
